const initialState = {
    generalClientParams: null,
    clientParams: null,
    subsParams: null,
    init: '',
    end: '',
    baseCnpj: '',
}

const state = { ...initialState }

const mutations = {
    SET_CONSIDER_REVISIONS(state, payload) {
        state.considerRevisions = payload
    },
    SET_GENERAL_CLIENT_PARAMS(state, payload) {
        state.generalClientParams = payload
    },
    SET_CLIENT_PARAMS(state, payload) {
        state.clientParams = payload
    },
    SET_SUBS_PARAMS(state, payload) {
        state.subsParams = payload
    },
    SET_INIT(state, payload) {
        state.init = payload
    },
    SET_END(state, payload) {
        state.end = payload
    },
    SET_BASE_CNPJ(state, payload) {
        state.baseCnpj = payload
    },
    RESET_STATE(state) {
        Object.assign(state, initialState)
    },
}

const getters = {
    GET_CONSIDER_REVISIONS(state) {
        return state.considerRevisions
    },
    GET_GENERAL_CLIENT_PARAMS(state) {
        return state.generalClientParams
    },
    GET_CLIENT_PARAMS(state) {
        return state.clientParams
    },
    GET_SUBS_PARAMS(state) {
        return state.subsParams
    },
    GET_INIT(state) {
        return state.init
    },
    GET_END(state) {
        return state.end
    },
    GET_BASE_CNPJ(state) {
        return state.baseCnpj
    },
}

const actions = {
    UPDATE_CONSIDER_REVISIONS({ commit }, payload) {
        commit('SET_CONSIDER_REVISIONS', payload)
    },
    UPDATE_GENERAL_CLIENT_PARAMS({ commit }, payload) {
        commit('SET_GENERAL_CLIENT_PARAMS', payload)
    },
    UPDATE_CLIENT_PARAMS({ commit }, payload) {
        commit('SET_CLIENT_PARAMS', payload)
    },
    UPDATE_SUBS_PARAMS({ commit }, payload) {
        commit('SET_SUBS_PARAMS', payload)
    },
    UPDATE_INIT({ commit }, payload) {
        commit('SET_INIT', payload)
    },
    UPDATE_END({ commit }, payload) {
        commit('SET_END', payload)
    },
    UPDATE_BASE_CNPJ({ commit }, payload) {
        commit('SET_BASE_CNPJ', payload)
    },
    RESET_STATE({ commit }) {
        commit('RESET_STATE')
    },
}

export default {
    state,
    mutations,
    getters,
    actions,
}
